import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import Navbar from "./components/Navbar";
import AdminPanel from "./routes/AdminPanel";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminLogin from "./routes/AdminLogin";
import Products from "./routes/Products";
import ProductsPage from "./routes/ProductsPage";
import ProductDetail from "./routes/ProductDetail";
import Checkout from "./routes/Checkout";
import Contact from "./routes/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/x-admin" element={<AdminLogin />} />
        <Route path="/produktet" element={<ProductsPage />} />
        <Route path="/produktet/:id" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        {/* <Route path="/kontakti" element={<Contact />} /> */}
        <Route
          path="/x-admin/panel"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
